import React, { Component } from "react";
import { connect } from "react-redux";

import { 
    deactivateRol, activateRol, createRol, updateRol, getRoles 
} from "../../../../actions/RolActions.js";
import { 
    DEACTIVATE_ROL, ACTIVATE_ROL, CREATE_ROL, UPDATE_ROL, GET_ERRORS, GET_ROLES 
} from "../../../../actions/types";
import RolModalComponent from './RolModalComponent';

import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import BootstrapTable from "react-bootstrap-table-next";
import LoadingOverlay from "react-loading-overlay";
import Snackbar from "@material-ui/core/Snackbar";
import Button from "@material-ui/core/Button";
import MuiAlert from "@material-ui/lab/Alert";
import Dialog from "@material-ui/core/Dialog";
import Icon from "@material-ui/core/Icon";

function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class RolComponent extends Component {
    state = {
        roles:                [],
        modalRolData:         null,
        textSnackBar:         "",
        modalType:            "CREATE",
		severitySnackBar:     "success",
        showDeactivateDialog: false,
        modalIsVisible:       false,
        showSnackBar:         false,
        activeLoader:         true,
        isActiveRol:          true,
        selectedId:           0,
    }

    constructor(props) {
        super(props);
        this.handleCloseDeactivateDialog = this.handleCloseDeactivateDialog.bind(this);
        this.onPressDeactivate           = this.onPressDeactivate.bind(this);
        this.onPressActivate             = this.onPressActivate.bind(this);
        this.onPressCancel               = this.onPressCancel.bind(this);
		this.deactivateRol               = this.deactivateRol.bind(this);
        this.onCloseModal                = this.onCloseModal.bind(this);
        this.activateRol                 = this.activateRol.bind(this);
        this.handleClose                 = this.handleClose.bind(this);
		this.createRol                   = this.createRol.bind(this);
        this.updateRol                   = this.updateRol.bind(this);
        this.openModal                   = this.openModal.bind(this);
	}

    componentDidMount() {
		this.props.getRoles();
	}

    componentDidUpdate(prevProps) {
		if (this.state.roles !== this.props.roles) {
			this.setState({
				roles: this.props.roles,
				activeLoader: false
			})
		}
        else if (this.props.actionType === CREATE_ROL && prevProps.actionType !== CREATE_ROL) {
			this.props.getRoles();
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Rol creado exitosamente.",
				severitySnackBar: 'success',
			});
		}
        else if (this.props.actionType === UPDATE_ROL && prevProps.actionType !== UPDATE_ROL) {
			this.props.getRoles();
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Rol actualizado exitosamente.",
				severitySnackBar: 'success',
			});
		}
        else if (this.props.actionType === ACTIVATE_ROL && prevProps.actionType !== ACTIVATE_ROL) {
			this.props.getRoles();
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Rol activado exitosamente.",
				severitySnackBar: 'success',
			});
		}
        else if (this.props.actionType === DEACTIVATE_ROL && prevProps.actionType !== DEACTIVATE_ROL) {
			this.props.getRoles();
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Rol desactivado exitosamente.",
				severitySnackBar: 'success',
			});
		}
		else if (this.props.actionType === GET_ERRORS && prevProps.actionType !== GET_ERRORS) {
			this.setState({
				showSnackBar: true,
				textSnackBar: this.props.error,
				severitySnackBar: 'error',
			});
		}
    }


    ///---------------------------------------EVENTS-------------------------------------

    openModal = () => {
		this.setState({
			modalIsVisible: true,
			modalType: "CREATE",
		});
	};

    handleCloseDeactivateDialog = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}
		this.setState({
			showDeactivateDialog: false,
		});
	};

    createRol(name, description, key) {
        this.props.createRol(name, description, key);
		this.setState({
            activeLoader: true,
			modalIsVisible: false,
		})
	}

    updateRol(_id, name, description, key) {
        this.props.updateRol(_id, name, description, key);
		this.setState({
            activeLoader: true,
			modalIsVisible: false,
		})
    }
    
    activateRol() {
        this.props.activateRol(this.state.selectedId);
        this.setState({
            showDeactivateDialog: false,
            modalIsVisible: false,
            selectedId: 0
        })
    }

    deactivateRol() {
        this.props.deactivateRol(this.state.selectedId);
        this.setState({
            showDeactivateDialog: false,
            modalIsVisible: false,
            selectedId: 0
        })
    }

    onPressDeactivate(id) {
        const idRol = id;
        this.setState({
            showDeactivateDialog: true,
            modalIsVisible: false,
            selectedId: idRol,
            isActiveRol: true
        });
	}

    onPressActivate(id) {
        const idRol = id;
        this.setState({
            showDeactivateDialog: true,
            modalIsVisible: false,
            selectedId: idRol,
            isActiveRol: false
        });
	}

    onPressCancel() {
		this.setState({
			modalIsVisible: false,
			modalRolData: null
		})
		this.render();
	}

    onCloseModal() {
		this.setState({
			activeLoader: true,
			modalIsVisible: false,
			modalRolData: null
		})
		this.render();
	}

    handleClose = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}

		this.setState({
			showSnackBar: false,
		});
	};


    ///---------------------------------------VIEW-------------------------------------
    render() {
      	const rowEvents = {
				onClick: (e, row, rowIndex) => {
					this.setState({
						modalType: "UPDATE",
						modalRolData: row,
						modalIsVisible: true,
					});
				},
			};
      	const columns = [
			{
				dataField: 'name',
				text: 'Nombre',
			},

			{
				dataField: 'description',
				text: 'Descripción',
				headerStyle: () => {
					return { width: "40%" };
				}
			},

			{
				dataField: 'key',
				text: 'Clave',
			},
			{
				dataField: 'created_at',
				text: 'Fecha de creación',
				formatter: (cell) => cell ? new Date(cell).toLocaleDateString() : ""
			},
            {
				dataField: 'is_active',
				text: 'Estatus',
                formatter: (cell) => (cell ? "Activo" : "Inactivo"),
			},
			];

        return ( 
            <center>
				<div className="toolbar end">
					<Button
						style={{
							height: "10%",
							backgroundColor: "#2ecc71",
							padding: "0.8rem 0.8rem",
							fontSize: "0.7rem",
						}}
						variant="contained"
						color="primary"
						startIcon={<Icon>add</Icon>}
						onClick={this.openModal}
					>
						Agregar
					</Button>
				</div>
				<div
					style={{
						textAlign: "left",
						height: "1vh",
						overflow: "auto",
						width: "100%",
						marginTop: "2vh",
					}}
				>
                </div>
                {this.state.roles && this.state.roles.length > 0 &&
                    <BootstrapTable
                        keyField="_id"
                        key="8908290138209"
                        striped
                        hover
                        condensed
                        rowEvents={rowEvents}
                        data={this.state.roles}
                        headerWrapperClasses="title-table"
                        rowClasses="custom-row-table"
                        columns={columns}
                    />
                }
                {
                    this.state.roles &&
                    <RolModalComponent
                        isVisible     = {this.state.modalIsVisible}
                        modalRolData  = {this.state.modalRolData}
                        deactivateRol = {this.onPressDeactivate}
                        type          = {this.state.modalType}
                        activateRol   = {this.onPressActivate}
                        onPressCancel = {this.onPressCancel}
                        onCloseModal  = {this.onCloseModal}
                        createRol     = {this.createRol}
                        updateRol     = {this.updateRol}
                    />
				}
                {
					<Dialog
						open={this.state.showDeactivateDialog}
						onClose={this.handleCloseDeactivateDialog}
						aria-labelledby="alert-dialog-title"
						aria-describedby="alert-dialog-description"
					>
						<DialogTitle id="alert-dialog-title">
							{"Desactivar rol"}
						</DialogTitle>
						<DialogContent>
                            { 
                                this.state.isActiveRol &&
                                <DialogContentText id="alert-dialog-description">
                                    ¿Seguro que deseas desactivar el rol?
                                </DialogContentText>
                            }
                            { 
                                this.state.isActiveRol === false &&
                                <DialogContentText id="alert-dialog-description">
                                    ¿Seguro que deseas activar el rol?
                                </DialogContentText>
                            }
						</DialogContent>
						<DialogActions>
							<Button
								onClick={this.handleCloseDeactivateDialog}
								color="secondary"
							>
								Cancelar
							</Button>
                            {
                                this.state.isActiveRol &&
                                <Button 
                                    onClick={this.deactivateRol} 
                                    color="primary" autoFocus
                                >
                                    Desactivar
                                </Button>
                            }
                            {
                                this.state.isActiveRol === false &&
                                <Button 
                                    onClick={this.activateRol} 
                                    color="primary" autoFocus
                                >
                                    Activar
                                </Button>
                            }
						</DialogActions>
					</Dialog>
				}
                {
					<LoadingOverlay
						active={this.state.activeLoader}
						isVisible={this.state.activeLoader}
						spinner
						text="Esto puede tardar unos minutos"
						styles={{
							wrapper: {
								width: this.state.activeLoader ? "100%" : "0%",
								height: this.state.activeLoader ? "100%" : "0%",
								overflow: "hidden",
							},
							overlay: (base) => ({
								...base,
								background: "rgba(10, 10, 10, 0.7)",
							}),
						}}
					></LoadingOverlay>
				}
                {
					<Snackbar
						open={this.state.showSnackBar}
						autoHideDuration={6000}
						onClose={this.handleClose}
					>
						<Alert
							onClose={this.handleClose}
							severity={this.state.severitySnackBar}
						>
							{this.state.textSnackBar}
						</Alert>
					</Snackbar>
				}
			</center>
        )
  	}
}

const mapStateToProps = state => ({
	roles: state.rol_reducer.roles,
    actionType: state.rol_reducer.actionType,
    error: state.rol_reducer.error,
	success: state.success,
});

export default connect(
    mapStateToProps, {
        deactivateRol,
		activateRol,
		createRol,
		updateRol,
		getRoles,
    }
)(RolComponent);